import { render, staticRenderFns } from "./SkillStatistics.vue?vue&type=template&id=0d048a35&"
import script from "./SkillStatistics.vue?vue&type=script&lang=ts&"
export * from "./SkillStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./SkillStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports